export default __webpack_public_path__ + "static/media/classic_2.81000f4e.jpg";